angular.module('tgaAdmin').controller('GameWofController', [
  '$scope', '$filter', '$log',
  function GameWofController(
    $scope, $filter, $log,
  ) {
    $scope.data.questionTypes = [
      {
        id: 'wof_regular',
        name: 'Spin Puzzle',
      },
      {
        id: 'wof_tossup',
        name: 'Toss Up',
      },
      {
        id: 'wof_bonus',
        name: 'Bonus Round',
      },
      {
        id: 'interstitial',
        name: 'Info Card',
      },
    ];

    $scope.data.questionTypesById = _.keyBy($scope.data.questionTypes, 'id');

    // Useful constants
    const boardRowLength = 14;
    const boardLineBreakers = [' ', '-'];

    // Default question object (with empty meta field)
    const defaultQuestion = {
      question_id: null,
      question_type: 'wof_regular',
      meta: {},
      // API or GameController require that the fields below exist.
      time: 0,
      randomize_answers: false,
      answers: [],
      advanced_feedback: [],
      translations: {},
    };

    // Question meta fields and defaults per-type
    const questionMetaDefaults = {
      all: {
        componentName: '',
        category: '',
        string: '',
        timerValue: 'normal', // slow | normal | fast; labelled "Time Setting"
        positions: [],
      },
      wof_regular: {
        aiDifficulty: 'normal', // easy | normal | hard; labelled "Virtual Helper Settings"
        useSolveBonus: true, // labelled "Include Solve Bonus"
        allowBankrupt: true, // labelled "Allow Bankruptcies"
      },
      wof_tossup: {
        revealSpeed: 1.5, // 1 | 1.5 | 2; labelled "Letter Speed"
        solveValue: 8000, // 6000 | 8000 | 10000; labelled "Value Setting"
      },
      wof_bonus: {
        solveValue: 8000, // 6000 | 8000 | 10000; labelled "Value Setting"
        consonantChoices: 3, // 0 - 5
        vowelChoices: 1, // 0 - 1
        preset: [
          { letter: 'R' },
          { letter: 'S' },
          { letter: 'T' },
          { letter: 'L' },
          { letter: 'N' },
          { letter: 'E' },
        ],
      },
    };

    const vowels = 'AEIOU';

    /**
     * Format an input string line into a suggested row array.
     */
    const formatByChar = (phrase, rowLength12Init) => {
      const phraseArr = phrase.split('');
      let rowLength12 = rowLength12Init;

      const rowDistribution = [];
      let currRow = [];
      let currWord = [];
      phraseArr.forEach((letter) => {
        if (boardLineBreakers.includes(letter)) {
          currRow = [...currRow, ...currWord];
          currWord = [];
        }

        if (currWord.length > (rowLength12 ? 12 : boardRowLength) - 1) {
          // wrap word
          const lastChar = currWord.pop();
          let penultimateChar = currWord.pop();
          if (penultimateChar == null) {
            penultimateChar = ' ';
          }
          if (currRow.length > 0) {
            currRow = [...currRow, ...currWord, penultimateChar];
          } else {
            currRow = [...currWord, penultimateChar];
          }
          if (penultimateChar !== ' ') {
            currRow.push('-');
          }
          rowDistribution.push(currRow);
          rowLength12 = rowDistribution.length === 3; // 4th row has 12 tiles
          currRow = [];
          currWord = [lastChar];
        } else if (currRow.length + currWord.length + 1 > (rowLength12 ? 12 : boardRowLength)) {
          // start word on new line
          rowDistribution.push(currRow);
          rowLength12 = rowDistribution.length === 3; // 4th row has 12 tiles
          currRow = [];
        }

        if (boardLineBreakers.includes(letter)) {
          currRow.push(letter);
        } else {
          currWord.push(letter);
        }
      });

      // add last part of the phrase
      if (boardLineBreakers.includes(phraseArr[phraseArr.length - 1])) {
        if (currRow.length + currWord.length > (rowLength12 ? 12 : boardRowLength)) {
          rowDistribution.push(currRow);
          currRow = [];
        }
        currRow = [...currRow, ...currWord];
        currWord = [];
      } else if (currRow.length + currWord.length > (rowLength12 ? 12 : boardRowLength)) {
        if (currRow.length > 0) {
          rowDistribution.push(currRow);
        }
        currRow = currWord;
      } else if (currRow.length > 0) {
        currRow = [...currRow, ...currWord];
      } else {
        currRow = currWord;
      }
      rowDistribution.push(currRow);

      rowDistribution.forEach((row) => {
        // remove lead space
        if (row[0] === ' ') {
          row.shift();
        }

        // remove trailing space
        let charLocation = row.length - 1;
        while (row[charLocation] === ' ') {
          row.pop();
          charLocation--;
        }
      });
      return rowDistribution.slice(0, 4);
    };

    /**
     * Generate `positions` tile array from predicted rows.
     */
    const makePositions = (rowDistribution) => {
      const positions = [];

      // start at row 1 if <=2 rows, start at row 0 otherwise
      let row = rowDistribution.length > 2 ? 0 : 1;

      // equal space on both sides, more space on left if odd
      const colInit = Math.ceil((boardRowLength - Math.max(...rowDistribution.map((x) => x.length))) / 2);
      let col = colInit;
      if (row === 0 && col === 0) {
        col++; // first row starts at col 1
      }

      // Collect positions.
      rowDistribution.forEach((currRow) => {
        currRow.forEach((letter) => {
          if (letter !== ' ') {
            const data = { row, col, letter };
            if (!letter.match(/[a-z]/i)) {
              data.specialChar = true;
            }
            positions.push(data);
          }
          col++;
        });
        row++;
        col = colInit; // justify left
        if (row === 3 && col === 0) {
          col++; // last row starts at col 1
        }
      });
      return positions;
    };
    // splices hyphens,new lines, and spaces into the new string
    const spliceSpecialBackIn = (array, c, newText) => {
      for (let i = 0; i < array.length; i++) {
        newText.splice(array[i], 0, c);
      }
    };
    // gives spaces, and new lines new positions depending on if they are in a
    // higher index than the hyphen its being compared to
    const assignNewPositions = (hyphen, array) => {
      for (let i = 0; i < hyphen.length; i++) {
        for (let n = 0; n < array.length; n++) {
          if (array[n] > hyphen[i]) {
            array[n]++;
          }
        }
      }
    };

    const evalQuestionMetaString = (string, question) => {
      const originalTextAreaValue = question.meta.string;
      const hyphenArray = [];
      const newLineArray = [];
      const spacesArray = [];
      // stripped takes out all the spaces and new  line returns from text area input
      const stripped = originalTextAreaValue.replace(/\s/g, '');
      // makes original text into an array so we know where new line and spaces are located
      const notStripped = originalTextAreaValue.split('');
      // newtextstring turns stripped text into an array to work with
      const newTextString = stripped.split('');

      // this if condition checked for difference in size between original text and game board text
      // it will always be different if our game board programtically added a hyphen
      if (string.length !== stripped.length) {
        // takes note of where new lines and spaces are before being stripped
        for (let i = 0; i < notStripped.length; i++) {
          if (notStripped[i] === '\n') {
            newLineArray.push(i);
          }
          if (notStripped[i] === ' ') {
            spacesArray.push(i);
          }
        }
        // locates all hyphens and puts them in a hyphens array
        for (let i = 0; i < string.length; i++) {
          if (string[i].letter === '-' && stripped[i] !== '-') {
            hyphenArray.push(i);
          }
        }
        // assigns new lines and spaces new positions
        assignNewPositions(hyphenArray, newLineArray);
        assignNewPositions(hyphenArray, spacesArray);

        // now we add new lines, hyphens and single space back into the text are input box
        spliceSpecialBackIn(hyphenArray, '-', newTextString);
        spliceSpecialBackIn(newLineArray, '\n', newTextString);
        spliceSpecialBackIn(spacesArray, ' ', newTextString);
        question.meta.string = newTextString.join('');
      }
    };

    /**
     * Process and normalize the `meta.string` of a question into `meta.positions`
     */
    $scope.actions.processStringForQuestion = (question) => {
      if (!_.isPlainObject(question.meta)) {
        question.meta = {};
      }
      const { meta } = question;

      if (!angular.isString(meta.string)) {
        meta.string = '';
      }
      const sentenceByReturns = meta.string
        .toUpperCase() // Uppercase letters.
        .replace(/[^\S\r\n]/g, ' ') // Replace tabs and exotic whitespace with single space.
        .split(/\r\n|\r|\n/g); // Split on newline(s).
      meta.string = sentenceByReturns.join('\n');

      const rowDistribution = [];
      let rowLength12 = false;
      sentenceByReturns.forEach((inputLine) => {
        // determine row length based on how many lines the puzzle will use
        if (rowDistribution.length === 1 || rowDistribution.length === 2) {
          rowLength12 = false;
        } else if (meta.string.length > 28 || sentenceByReturns.length > 2) {
          rowLength12 = true;
        }
        const newRows = formatByChar(inputLine, rowLength12);
        rowDistribution.push(...newRows);
      });

      if (!angular.isArray(meta.positions)) {
        question.meta.positions = [];
      }
      const newPositions = makePositions(rowDistribution);
      // check to see if text area needs to be updated
      evalQuestionMetaString(newPositions, question);

      meta.positions.splice(0, meta.positions.length, ...newPositions);
    };

    /**
     * Add type-appropriate properties with default values to a question,
     * and sanitize some fields when types change.
     */
    $scope.actions.populateQuestion = (question) => {
      if (question == null || question.question_type == null) {
        return question;
      }

      // Sets min/max answers, adds missing, crops extra.
      $scope.actions.changeQuestionType(question);

      // Interstitials have no puzzle data, so clear `meta` and bail out.
      if (question.question_type === 'interstitial') {
        question.meta = {};
        return question;
      }

      // Puzzle types don't use rich-text in question.text
      if (angular.isString(question.text)) {
        question.text = $filter('htmlToPlaintext')(question.text);
      }

      // Ensure `question.meta` object exists
      if (!angular.isObject(question.meta)) {
        question.meta = {};
      }

      // Ensure `question.meta` object has expected properties.
      // Add defaults when properties are missing.
      _.defaults(
        question.meta,
        angular.copy(questionMetaDefaults.all),
        angular.copy(questionMetaDefaults[question.question_type]),
      );

      return question;
    };

    /**
     * Removes type-inappropriate properties from a question, and ensures
     * certain properties are set correctly.
     * Meant for use immediately prior to saving.
     */
    $scope.actions.cleanQuestion = (question) => {
      if (question == null || question.question_type == null) {
        return question;
      }

      // `GameController.changeQuestionType` should ensure questions have
      // min/max and dummy answers, but we'll re-confirm here.
      const maxAnswers = _.toLength(question.max_answers);
      const minAnswers = _.toLength(question.min_answers);
      question.answers.splice(0, maxAnswers);
      while (question.answers.length < minAnswers) {
        $scope.actions.addAnswer(question);
      }

      // Ensure only the first answer is correct, and all are 'empty'.
      question.answers.forEach((answer, i) => {
        answer.correct = i === 0;
        answer.type = 'empty';
      });

      // Interstitials have no puzzle data, so clear `meta` and bail out.
      if (question.question_type === 'interstitial') {
        question.meta = {};
        return question;
      }

      // Puzzles set their `question.text` based on type and puzzle string, consumed in reports downloads
      // The "Component Name" is currently organizational window-dressing, and stays in meta
      const stringMeta = question.meta.string ? question.meta.string : '*** empty puzzle ***';
      question.text = `${$scope.data.questionTypesById[question.question_type].name}: ${stringMeta}`;
      $log.debug(`Setting question text for WOF puzzle: ${question.text}`);

      // Puzzle types have no image or video.
      question.image = null;
      question.video = null;

      // Ensure `question.meta` object exists.
      if (!angular.isObject(question.meta)) {
        question.meta = {};
      }

      // Filter puzzle `meta` keys based on question type.
      const keyWhitelist = [
        ..._.keys(questionMetaDefaults.all),
        ..._.keys(questionMetaDefaults[question.question_type]),
      ];
      const keysToDelete = _.difference(_.keys(question.meta), keyWhitelist);
      _.forEach(keysToDelete, (key) => delete question.meta[key]);

      return question;
    };

    /**
     * Add a new empty component to the game.
     */
    $scope.actions.addComponent = (questionType) => {
      const newQuestion = angular.copy(defaultQuestion);
      if (questionType != null) {
        newQuestion.question_type = questionType;
      }
      $scope.actions.populateQuestion(newQuestion);

      $scope.viewmodel.game.questions.push(newQuestion);
      $scope.gameForm.$setDirty();
      $scope.actions.toggleCollapse($scope.viewmodel.game.questions.length - 1);
    };

    /**
     * WoF-specific save action. Pre-process before saving.
     */
    $scope.actions.wofPreprocessAndSubmit = () => {
      // Clean all questions
      _.forEach($scope.viewmodel.game.questions, $scope.actions.cleanQuestion);

      $scope.actions.checkGameForm();
    };

    /**
     * Callback to notify the controller that a question has been updated.
     * Used for components like <wof-tilesorter> that modify their one-way bound objects to notify of changes.
     */
    // eslint-disable-next-line no-unused-vars
    $scope.actions.questionUpdated = (question) => {
      $scope.gameForm.$setDirty();

      // This ensures asterisks and things appear immediately.
      // eslint-disable-next-line angular/no-private-call
      if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
        $scope.$apply();
      }
    };

    /**
     * Check if preset uses all the vowels
     */
    $scope.actions.checkVowelCount = (preset, question) => {
      const noVowelsRemaining = vowels.length === _.filter(preset, (p) => _.includes(vowels, p.letter)).length;
      // force set vowel count when all vowels are used in preset
      if (noVowelsRemaining && question) {
        question.meta.vowelChoices = 0;
      }
      return noVowelsRemaining;
    };
  },
]);
